import { API_BASE_URL } from '../constants';
import { ApiResponse, handleRequest } from '../utils';
import axiosInstance from './axiosInstance';
import { Admin } from '../types';

export const AdminService = {
  getAdmin: async (): Promise<ApiResponse<Admin>> => {
    return handleRequest<Admin>(async () => {
      return axiosInstance.get(`${API_BASE_URL}/users/me`);
    });
  },
  setLanguage: async (language: string): Promise<ApiResponse<Admin>> => {
    return handleRequest<Admin>(async () => {
      return axiosInstance.patch(`${API_BASE_URL}/users/settings`, { language });
    });
  },
};
